/**
 * React Router configuration for the web panel.
 *
 * All 9 routes per D-03: dashboard, accounts, accounts/:id, integrations,
 * commands, events, sales, audit, settings. Root redirects to /dashboard.
 *
 * Authenticated routes use AppLayout which provides the sidebar + content shell.
 * Login page renders outside the layout.
 */
import { createBrowserRouter, Navigate } from 'react-router';
import { AppLayout } from './app';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: '/login',
    lazy: () => import('./pages/login').then((m) => ({ Component: m.default })),
  },
  {
    element: <AppLayout />,
    children: [
      {
        path: '/dashboard',
        lazy: () =>
          import('./pages/dashboard').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/accounts',
        lazy: () =>
          import('./pages/accounts-list').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/accounts/:id',
        lazy: () =>
          import('./pages/account-detail').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/integrations',
        lazy: () =>
          import('./pages/integrations').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/commands',
        lazy: () =>
          import('./pages/commands').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/events',
        lazy: () =>
          import('./pages/events').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/sales',
        lazy: () =>
          import('./pages/sales').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/audit',
        lazy: () =>
          import('./pages/audit').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '/settings',
        lazy: () =>
          import('./pages/settings').then((m) => ({
            Component: m.default,
          })),
      },
    ],
  },
]);
